import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrderService } from 'src/app/services/order.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';

declare const $: any;

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent {
    constructor(
        private location: Location,
        private utils: UtilsService,
        private apiService: OrderService,
        private spinner: NgxSpinnerService,
        private router: Router
    ) {
    }

    order: any = {}
    dataUser: any = {}
    evidence_1: boolean = false
    evidence_2: boolean = false
    type_text: any = ""
    evidences: any = []
    evidenceSlides: any[][] = []
    files: any = []
    allGetEvidences: any = []
    // Precomputed lists to avoid filtering on every change detection
    evidenceCarga: any[] = []
    evidenceDescarga: any[] = []
    finishEvidence: boolean = false
    logs: any = []
    finishLog: boolean = false
    url_page = environment.url_page
    status: any[] = []
    address_service_id: any = null
    next_address_service_id: any = null
    effectiveStatusText: string = ''
    effectiveStatusColor: string = ''
    effectiveStatusId: number = 0
    indexAddressCurrent: number = 0
    ngOnInit() {
        let data: any = this.location.getState()
        this.order = data.data
        this.status = data.status
        this.dataUser = this.utils.getDataUser()
        this.address_service_id = data.address_service_id
        this.next_address_service_id = data.next_address_service_id
        this.evidence_1 = this.order.status_id_one != null && this.order.status_id_one > 0 ? true : false
        this.evidence_2 = this.order.status_id_two != null && this.order.status_id_two > 0 ? true : false

        this.computeEffectiveStatus();
        this.allEvidences()
        this.logsService()
    }

    private computeEffectiveStatus() {
        try {
            const serviceStatusId = Number(this.order?.status_id);
            const serviceStatusText = String(this.order?.status ?? '');
            const serviceColor = String(this.order?.status_color ?? '');
            const addr = Array.isArray(this.order?.address_services) ? this.order.address_services : [];
            if (addr.length > 0 && serviceStatusId === 5) {
                const target = addr.find((a: any) => Number(a?.status_id) !== 5);
                if (target) {
                    this.effectiveStatusText = String(target?.status ?? serviceStatusText);
                    this.order.status_id = Number(target?.status_id ?? serviceStatusId);
                    this.effectiveStatusColor = String(target?.status_color ?? serviceColor);
                    this.indexAddressCurrent = addr.indexOf(target) + 1;
                    return;
                }
            }
            // Fallback to service
            this.effectiveStatusText = serviceStatusText;
            this.effectiveStatusColor = serviceColor;
        } catch {
            this.effectiveStatusText = String(this.order?.status ?? '');
            this.effectiveStatusColor = String(this.order?.status_color ?? '');
        }
    }

    // Map evidence identifier (1-based) to letter label starting at A (1->A, 2->B, ... up to Z)
    identifierToLetter(id: any): string {
        const num = Number(id);
        if (!isFinite(num) || num <= 0) return '';
        const alphabet = 'BCDEFGHIJKLMNOPQRSTUVWXYZ';
        const idx = Math.floor(num - 1);
        return alphabet[Math.min(idx, alphabet.length - 1)];
    }

    modalActiveEvidence() {
        $("#modalEvidence").modal("show")
    }
    allEvidences() {
        // set loading state
        this.finishEvidence = false
        this.apiService.getAllEvidences({ orden_id: this.order.id }).subscribe((resp) => {
            this.allGetEvidences = resp || []
            // Pre-split evidences by status to minimize template work
            this.evidenceCarga = this.allGetEvidences.filter((e: any) => e?.status_id == 3)
            this.evidenceDescarga = this.allGetEvidences.filter((e: any) => e?.status_id == 8)
            // Update quick flags for UI sections
            this.evidence_1 = this.evidenceCarga.length > 0 || (this.order.status_id_one != null && this.order.status_id_one > 0)
            this.evidence_2 = this.evidenceDescarga.length > 0 || (this.order.status_id_two != null && this.order.status_id_two > 0)
            this.finishEvidence = true
        }, (error) => {
            this.evidenceCarga = []
            this.evidenceDescarga = []
            this.finishEvidence = true
        })
    }

    modalOpenEvidence(status_id: any) {
        this.type_text = status_id == 3 ? "Carga" : "Descarga"
        this.spinner.show()
        this.apiService.getEvidences({ orden_id: this.order.id, status_id: status_id }).subscribe((resp) => {
            this.spinner.hide()
            this.evidences = resp
            this.evidenceSlides = this.chunkArray(this.evidences, 4)
            $("#modalEvidenceShow").modal("show")
        }, (error) => {
            this.spinner.hide()
        })
    }

    private chunkArray(arr: any[], size: number): any[][] {
        const out: any[][] = [];
        if (!Array.isArray(arr) || size <= 0) return out;
        for (let i = 0; i < arr.length; i += size) {
            out.push(arr.slice(i, i + size));
        }
        return out;
    }

    onSelect(event: any) {
        // Avoid duplicates by name + size
        const existing = new Set(this.files.map((f: any) => `${f.name}|${f.size}`))
        for (const f of event.addedFiles || []) {
            const key = `${f.name}|${f.size}`
            if (!existing.has(key)) {
                this.files.push(f)
            }
        }
    }

    onRemove(event: any) {
        this.files.splice(this.files.indexOf(event), 1);
    }

    uploadEvidences() {

        if (!this.files?.length) return;
        $("#modalEvidence").modal("hide")
        this.spinner.show()
        const formData = new FormData();
        for (let i = 0; i < this.files.length; i++) {
            formData.append("file[]", this.files[i]);
        }
        const nextStatus = this.getNextStatusId();
        this.apiService.uploadFile(formData, this.order.id, this.order.status_id, this.dataUser.id, nextStatus, this.address_service_id, this.next_address_service_id, this.indexAddressCurrent).subscribe((resp) => {
            this.spinner.hide()
            this.files = []
            // Refresh evidence lists so the UI updates immediately
            this.allEvidences()
            this.utils.alertSwal({ title: "Evidencias", text: "Se han cargado las evidencias de forma exitosa", icon: "success" })
        }, (error) => {
            this.spinner.hide()
            this.utils.alertSwal({ title: "Evidencias", text: "Se han presentado un error en el cargue de las evidencias", icon: "error" })
        })
    }
    filterEvidences(status: number) {
        // Kept for backwards compatibility; prefer using precomputed arrays
        if (status === 3) return this.evidenceCarga
        if (status === 4) return this.evidenceDescarga
        return this.allGetEvidences.filter((resp: any) => resp?.status_id == status)
    }
    logsService() {
        this.finishLog = true
        this.logs = this.order.logs
    }
    observationUpdate(event: any) {
        let val = event.target.value ? event.target.value : null
        if (val == this.order.observation) {
            this.utils.alertSwal({ title: "Notas", text: "No se produjo cambios para actualizar", icon: "info" })
        } else {
            this.updateObservationSend(val)
        }
    }
    updateObservationSend(value: any) {
        this.spinner.show()
        this.apiService.observation({ observation: value }, this.order.id).subscribe((resp) => {
            this.utils.alertSwal({ text: "Se actualizado la nota de forma exitosa.", title: "Notas del servicio.", icon: "success" });
            this.order.observation = value
            this.spinner.hide()
        }, (error) => {
            this.spinner.hide();
            this.utils.alertSwal({ title: "Observación ", text: "Se han presentado un error al actualizar la nota", icon: "error" })
        })
    }
    dowloandService() {
        let url = environment.url_page
        window.open(url + '/generate-pdf/' + this.order.id, "_blank")
    }

    cancelOrder() {

        this.utils.alertSwalConfir({ text: "Esta seguro que desea cancelar el servicio", title: "Cancelación del servicio", icon: "warning", btn_confirm: "Aceptar" }).then((resp) => {
            if (resp.isConfirmed) {
                this.spinner.show()
                this.apiService.cancelOrder(this.order.id, this.dataUser.id).subscribe((response) => {
                    this.utils.alertSwal({ text: "Se ha realizado la cancelación del servicio de forma exitosa.", title: "Cancelacion del servicio.", icon: "success" });
                    this.spinner.hide()
                })
            } else {
                this.spinner.hide()
            }
        })
    }

    changedUnit() {
        // Asegurarse de que todos los datos necesarios estén incluidos
        const orderData = {
            ...this.order,
            // Asegurar que los campos del trailer estén presentes
            requires_trailer: this.order.requires_trailer || false,
            trailer_id: this.order.trailer_id || ''
        };
        
        this.router.navigateByUrl('/service/changed-unit', { state: orderData });
    }

    /**
     * Returns the full status object for a given status_id from the provided status list.
     */
    filterStatus(status_id: any) {
        return this.status.find((resp: any) => resp?.id == status_id);
    }

    /**
     * Whether current order status requires evidences according to status configuration.
     */
    requiresEvidence(): boolean {
        const st = this.filterStatus(this.order?.status_id);
        // Some APIs may return 1/0 or true/false
        return !!(st && (st.required_evidence === true || st.required_evidence === 1));
    }

    /**
     * Whether the user can upload load evidences (status 3) right now.
     */
    canUploadCarga(): boolean {
        if (this.dataUser?.type_admin === 4) return false;
        return this.order?.status_id === 3 && this.requiresEvidence() && !this.evidence_1;
    }

    /**
     * Whether the user can upload unload evidences (status 4) right now.
     */
    canUploadDescarga(): boolean {
        if (this.dataUser?.type_admin === 4) return false;
        return this.order?.status_id === 8 && this.requiresEvidence();
    }

    /**
     * Try to resolve the next status id from current status config. Fallback to current status if not found.
     */
    private getNextStatusId(): any {
        const st: any = this.filterStatus(this.order?.status_id) || {};
        // Prefer explicit fields if backend provides them
        const explicit = st.next_status ?? st.next_status_id ?? st.nextId ?? null;
        if (explicit != null && explicit !== undefined) return explicit;
        // Simple heuristic fallback if no explicit mapping is provided
        // Adjust these defaults if your workflow differs
        switch (this.order?.status_id) {
            case 3: // Carga evidences usually lead to Descarga step
                return 8; // If your Descarga status is 8; change if needed
            default:
                return this.order?.status_id; // No change if unknown
        }
    }

    // TrackBy helpers to minimize DOM re-rendering
    trackByEvidence = (_: number, item: any) => item?.id ?? `${item?.img}|${item?.status_id}`
    trackByLogIndex = (index: number) => index
}
